import React from 'react';
import Layout from '../components/layout';
import HostcupNav from '../components/Hostcup/HostcupNav';
import CoverImage from '../components/CoverImage/CoverImage'


export default ({pageContext}) => (
    <Layout>
        <CoverImage text={pageContext.title} image="https://images.pexels.com/photos/3820994/pexels-photo-3820994.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260" />
        <HostcupNav />
        <div dangerouslySetInnerHTML={{__html: pageContext.content}}></div>
    </Layout>
);